import React from 'react';
import { connect } from 'react-redux';
import { focus } from 'redux-form';
import _ from 'lodash';

import { scrollNamedElementIntoView } from 'shared/utils/common';

import { findFirstErrorField } from './utils';

const AutoScrollableForm = WrappedComponent => {
  // Must be used before the form is wrapped with `reduxForm` in order to receive all required props

  class HOC extends React.Component {
    componentDidUpdate(prevProps) {
      const prevForm = prevProps.forms[this.props.form];
      const form = this.props.forms[this.props.form];

      if (!_.isNil(form.submitErrors) && _.isNil(prevForm.submitErrors)) {
        const fieldName = findFirstErrorField(
          form.registeredFields,
          form.submitErrors
        );

        scrollNamedElementIntoView(fieldName);
      }
    }

    render() {
      const { forms, ...rest } = this.props;

      return (
        <WrappedComponent ref={element => (this.wrapped = element)} {...rest} />
      );
    }
  }

  const mapStateToProps = state => ({
    forms: state.form
  });

  const mapDispatchToProps = {
    focus
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(HOC);
};

export default AutoScrollableForm;
